import dayjs from "dayjs";
import { useMemo } from "react";

export const useSetInitialData = (data: any) => {
  const initialValues = useMemo(() => {
    if (!data) {
      const scheduledDate = dayjs().hour(8);

      const year = scheduledDate.get("year") + 5;

      return {
        frequencyType: 1,
        scheduledDate: dayjs().hour(8),
        maxOccurrences: 5,
        endDate: scheduledDate.year(year),
        endConditionType: 3,
      };
    }

    return data;
  }, [data]);

  return { initialValues };
};
